import React, { useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";
import { Button } from "@material-ui/core";
import getDevicesControlLogAPI from "@/apis/getDevicesControlLogAPI";
import Modal from "@/components/Modal";
import { DeviceControlLogDetailDatatable } from "@/helpers/DeviceControlLogDetailDatatable";

import CompanySettingMain from "./CompanySettingMain";

const CompanySetting = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusId, setStatusId] = useState('')
  const [loading, setLoading] = useState(false)
  const settingRef = useRef(null)

  const checkStatus = async () => {
    setLoading(true)
    const res = await getDevicesControlLogAPI({
      task_type: 'ora_update_ora_auto_upd', 
      columns: [{data: "created_at", orderable: true}],
      order: [{column: 0, dir: 'desc'}]
    })
    setStatusId(res.data[0].id)
    setStatusModalOpen(true)
    setLoading(false)
  }

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "公司设置" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "公司设置" })}
        </Typography>
        <Button
          color="primary"
          variant="outlined"
          type="button"
          style={{marginLeft: 'auto'}}
          onClick={checkStatus}
          disabled={loading}
        >
          {t({defaultMessage: "查看设置套用状态"})}
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="button"
          style={{marginLeft: 16}}
          onClick={() => settingRef.current?.save()}
          disabled={loading}
        >
          {t({defaultMessage: "保存"})}
        </Button>
      </div>
      <div className={classes.paperWrapper}>
        <CompanySettingMain ref={settingRef} />
      </div>
      <Modal
        title={t({ defaultMessage: "命令状态详情" })}
        width={960}
        open={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        onConfirm={() => setStatusModalOpen(false)}
      >
        <DeviceControlLogDetailDatatable groupId={statusId} />
      </Modal>
    </>
  );
};

export default CompanySetting;
